import { render, staticRenderFns } from "./ImageUploadForm.vue?vue&type=template&id=0bba96ab&"
import script from "./ImageUploadForm.vue?vue&type=script&lang=ts&"
export * from "./ImageUploadForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports